import React, { useState, useEffect } from "react";
import moment from "moment-timezone"; // Import moment-timezone

import ExpiredProgramCard from "./ExpiredProgramCard";
import ActiveProgramCard from "./ActiveProgramCard";
import Styles from "./Programs.module.css";

import { useTranslation } from "react-i18next";
import guideDataEN from "../../../../i18n/translations/GuideData/GuideDataEn";
import guideDataAr from "../../../../i18n/translations/GuideData/GuideDataAr";
import guideDataKu from "../../../../i18n/translations/GuideData/GuideDataKu";
import { useParams } from "react-router-dom";

function Programs() {
	const { t, i18n } = useTranslation();
	const { id } = useParams();

	const currentLanguage = i18n.language;
	const guideData =
		currentLanguage === "en"
			? guideDataEN
			: currentLanguage === "ar"
			? guideDataAr
			: guideDataKu;

	// Find Guide by his ID
	const guide = guideData.filter(
		(guide) => guide.idGuide.toString() === id.toString()
	)[0];

	// is Rtl or not
	const isRtl =
		i18n.language === "ar" || i18n.language === "ku";

	const [activePrograms, setActivePrograms] = useState([]);
	const [expiredPrograms, setExpiredPrograms] = useState(
		[]
	);
	const [programsToShow, setProgramsToShow] = useState([]);

	useEffect(() => {
		// Filter Active programs based on the current date
		const filteredActivePrograms =
			guide.ProgramsData.filter((program) => {
				moment(program.startDate).isSameOrAfter(
					moment().unix()
				);
				console.log(
					moment(
						moment(Number(program.startDate) * 1000).format(
							"YYYYMMDDkkmmss"
						),
						"YYYYMMDDkkmmss"
					).fromNow()
				);
				console.log(
					moment(Number(program.startDate) * 1000).format(
						"YYYY-MM-DD"
					)
				);
				//  console.log( moment(moment(Number( program.startDate)*1000).format("YYYYMMDDkkmmss"),"YYYYMMDDkkmmss").fromNow()); //the output like this in 3 months
				return Number(program.startDate) >= moment().unix();

				// console.log(moment(program.startDate, "YYYY-MM-DD").fromNow()); InvalidDate
				// console.log(moment(program.startDate).unix().fromNow()); to convert it to unix and compare it with current date
				// console.log(moment().unix()); //get currentDate in unix
			});
		const filteredExpiredPrograms =
			guide.ProgramsData.filter((program) => {
				return Number(program.startDate) < moment().unix();
			});

		// Update state
		setActivePrograms(filteredActivePrograms);
		setExpiredPrograms(filteredExpiredPrograms);
		setProgramsToShow(filteredActivePrograms); // Set default programsToShow to activePrograms
	}, [guide.ProgramsData]);

	const handleActiveProgramsClick = () =>
		setProgramsToShow(activePrograms);
	const handleExpiredProgramsClick = () =>
		setProgramsToShow(expiredPrograms);

	return (
		<div
			className={Styles.programContainer}
			dir={isRtl ? "rtl" : "ltr"}
		>
			<h2 className={Styles.h2}>
				{t("GuideProfile.programs")}
			</h2>
			<div className={Styles.buttonContainer}>
				<button
					onClick={handleActiveProgramsClick}
					className={
						programsToShow === activePrograms
							? Styles.activeTabBtn
							: Styles.tabBtn
					}
				>
					{t("GuideProfile.activeProgram")}
				</button>
				<button
					onClick={handleExpiredProgramsClick}
					className={
						programsToShow === expiredPrograms
							? Styles.expiredTabBtn
							: Styles.tabBtn
					}
				>
					{t("GuideProfile.expiredProgram")}
				</button>
			</div>

			<div className={Styles.programGrid}>
				{programsToShow.map((program) => {
					const programStartDate = moment(Number(program.startDate) * 1000).format(
						"YYYY-MM-DD");
					
					console.log(programStartDate,"start");

					return (
						<div
							key={program.id}
							className={Styles.programGrid}
						>						
							{program.startDate < moment().unix() ? (
								<div>
									<ExpiredProgramCard
										id={program.id}
										image={program.image}
										imgCover={program.imgCover}
										name={program.name}
										describe={program.describe}
										cost={program.cost}
										duration={program.duration}
										startDate={programStartDate}
										schedule={program.schedule}
									/>
								</div>
							) : (
								<div>
									<ActiveProgramCard
										id={program.id}
										image={program.image}
										imgCover={program.imgCover}
										name={program.name}
										describe={program.describe}
										cost={program.cost}
										duration={program.duration}
										startDate={programStartDate}
										schedule={program.schedule}
									/>
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default Programs;
